import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CONSTANTS } from '../../data';
import { sounds } from '../../systems/AudioSystem';

interface StoryScreenProps {
  onComplete: () => void;
}

export const StoryScreen: React.FC<StoryScreenProps> = ({ onComplete }) => {
  const [storyTextIndex, setStoryTextIndex] = useState(0);

  useEffect(() => {
    if (storyTextIndex < CONSTANTS.OPENING_STORY.texts.length) {
      const timer = setTimeout(() => {
        setStoryTextIndex(prevIndex => prevIndex + 1);
      }, CONSTANTS.OPENING_STORY.durationMs);
      
      return () => clearTimeout(timer);
    }
  }, [storyTextIndex]);

  return (
    <div className="story-screen">
      <div className="story-text-container">
        {storyTextIndex < CONSTANTS.OPENING_STORY.texts.length ? (
          <AnimatePresence mode="wait">
            <motion.div
              key={storyTextIndex}
              className="story-text"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              {CONSTANTS.OPENING_STORY.texts[storyTextIndex]}
            </motion.div>
          </AnimatePresence>
        ) : (
          <motion.button
            id="begin-btn"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
            onClick={() => {
              sounds.buttonClick();
              onComplete();
            }}
          >
            {CONSTANTS.OPENING_STORY.buttonText}
          </motion.button>
        )}
      </div>
    </div>
  );
};
